/**
 * The autopilot (docs/spec/05 §4): plays a running game through the real engine, for the title
 * screen's attract demo and for the tests that run the engine for minutes at a time. Pure and
 * deterministic: the same states and the same options give the same inputs.
 */

import type { GameState, Input } from '../sim';
import { Pilot } from './pilot';

export interface Autopilot {
  /** The input for the next tick, given the state now. Reads the state, never writes it. */
  next(state: GameState): Input;
}

export interface AutopilotOptions {
  /** Seeds the bot's own small choices (which target when several are as good). Default 1. */
  readonly seed?: number;
  /**
   * 0-1: how good it is. 1 = as well as it can; lower = slower reactions, more misses (the demo
   * uses ~0.8). Default 1.
   */
  readonly skill?: number;
}

export function createAutopilot(options: AutopilotOptions = {}): Autopilot {
  return new Pilot(options.seed ?? 1, options.skill ?? 1);
}
